import React from "react";
import { Button } from "@/components/ui/button";
import { X, Send, CheckCircle2 } from "lucide-react";

export const ContactNowBanner = ({ items, label = "contatti", onContact, onDismiss }) => {
  if (!items || items.length === 0) return null;
  const n = items.length;
  return (
    <div data-testid="contact-now-banner"
      className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-emerald-300 bg-emerald-50 px-4 py-3 dark:border-emerald-900/40 dark:bg-emerald-950/20">
      <div className="flex items-center gap-2.5 text-sm">
        <CheckCircle2 className="h-5 w-5 shrink-0 text-emerald-600" />
        <span className="font-medium text-emerald-900 dark:text-emerald-200">
          Hai aggiunto {n} {label} all'archivio. Vuoi scrivere subito?
        </span>
      </div>
      <div className="flex items-center gap-1.5">
        <Button size="sm" onClick={onContact} data-testid="contact-now-btn"
          className="gap-1.5 rounded-full bg-emerald-600 font-semibold text-white hover:bg-emerald-700">
          <Send className="h-3.5 w-3.5" /> Contatta subito{n > 1 ? ` (${n})` : ""}
        </Button>
        <Button size="icon" variant="ghost" onClick={onDismiss} data-testid="contact-now-dismiss"
          className="h-8 w-8 text-emerald-700 hover:bg-emerald-100 dark:text-emerald-300 dark:hover:bg-emerald-900/40">
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
};

export default ContactNowBanner;
